import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AddressComponent } from './address.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SpinnerModule } from '@spartacus/storefront'
import { NgSelectModule } from '@ng-select/ng-select'
import { ConfigModule, I18nModule } from '@spartacus/core'
import { environment } from '../../../../environments/environment'
// import { Ng2SearchPipeModule } from 'ng2-search-filter';

@NgModule({
  declarations: [AddressComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SpinnerModule,
    NgSelectModule,
    I18nModule,
    // Ng2SearchPipeModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['addressData'],
        },
      },
    }),
  ],
  exports: [AddressComponent],
})
export class AddressModule {}
